import styled from 'styled-components';
import LatestIcon from '../Assets/LatestIcon.svg';
import { Body1, H3 } from "../style-comps/Common.styles";


export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 300px;
  height: auto;
  position: relative;
  gap: 10px;

    @media (max-width: 768px) {
        width:100%;
    }
`;

export const HeaderContainer = styled(H3)`
  display: flex;
  justify-content: start;
  align-items: center;
  gap:20px;
  background-color:rgba(97, 203, 201, 0.5);
  border-radius: 12px 12px 0 0;
  padding:12px;
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  background-image: url(${LatestIcon});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const LatestText = styled(H3)`
  margin: 0;
`;


export const LatestNoiftDropdown = styled.div`
  padding:0px 8px;
`;

export const LatestNoiftItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
  font-size: 14px;
  color: #333;
  padding:12px;
  border-bottom: 1px solid #f2f4f8;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #61cbc9;
    color: #fff;
    border-radius: 8px;
  }

  &:last-child {
    border-bottom: none;
  }
`;
